// Key-value store keys
export const KV_KEYS = {
  BLOG_POSTS: 'blog_posts',
  PROCESSING_STATUS: 'processing_status',
} as const;

export const TARGET_NODE_ID = "d5d5c476-ac06-4841-bb9d-b0e01ff9c075";
export const ORIGINAL_CONTENT_NODE_ID = "bb1cc2dd-3ee4-4ff5-aa66-77889900aabb";

export enum KeyValEntityType {
  TASKS_TODO_BUCKET = 'TASKS_BPCR_TODO',
  TASKS_IN_PROGRESS_BUCKET = 'TASKS_BPCR_IN_PROGRESS',
  TASKS_WAITING_FOR_APPROVAL_BUCKET = 'TASKS_BPCR_WAITING_FOR_APPROVAL',
  TASKS_COMPLETED_BUCKET = 'TASKS_BPCR_COMPLETED',
  TASKS_FAILED_BUCKET = 'TASKS_BPCR_FAILED',
}

// TODO: make this configurable
export const APP_NAME = 'kv_task_queue'

const BASE_PATH = '/ui/agent/blog-post-content-refresher'

export const ROUTES = {
  BASE: BASE_PATH,
  OUTPUT: `${BASE_PATH}/output`,
  review: (workflowExecutionId: string) => `${BASE_PATH}/review/${workflowExecutionId}`,
  result: (workflowExecutionId: string) => `${BASE_PATH}/result/${workflowExecutionId}`,
} as const
